import React from "react";
import IconButton from "@mui/material/IconButton";
import RepeatIcon from "@mui/icons-material/Repeat";
import { Tooltip } from "@mui/material";

const ReInitiateVlmCheckbox = ({
  parameterData,
  disabled,
  handleChangeReProcess,
}) => {
  // Validate parameterData and its nested properties
  const isReInitiated = parameterData?.mappings?.[0]?.reInitiateProVlm;

  return (
    <div>
      {isReInitiated ? (
        <Tooltip
          placement="top"
          title={
            parameterData.mappings[0]?.reInitiateProVlm &&
            parameterData.mappings[0]?.proVlmTagName &&
            parameterData.mappings[0]?.proVlmPageNo >= 0
              ? `${parameterData.mappings[0]?.proVlmTagName} - ${
                  parseInt(parameterData.mappings[0]?.proVlmPageNo) + 1
                }`
              : ""
          }
          arrow
        >
          <IconButton
            onClick={() =>
              handleChangeReProcess(
                !parameterData.mappings[0]?.reInitiateProVlm
              )
            }
            disabled={disabled}
            size="small"
            aria-label="toggle reprocess"
            sx={{
              color: "green", // Highlight color for active state
              backgroundColor: "rgba(1, 90, 1, 0.1)", // Light green background
              "&:hover": {
                backgroundColor: "rgba(1, 83, 1, 0.2)", // Darker green on hover
              },
            }}
          >
            <RepeatIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton
          onClick={() => handleChangeReProcess(true)}
          disabled={disabled}
          size="small"
          aria-label="toggle reprocess"
        >
          <RepeatIcon />
        </IconButton>
      )}
    </div>
  );
};

export default ReInitiateVlmCheckbox;
